import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CrumbOptionsProvider } from './crumbOptionsProvider';
import { AuthProvider } from 'react-oidc-context';
import { RoleProvider } from './roleProvider';

const config = {
  authority: process.env.REACT_APP_KEYCLOAK_AUTHORITY,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URI + '/id-registraties',
}
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <CrumbOptionsProvider>
      <AuthProvider {...config}>
        <RoleProvider>
          <App />
        </RoleProvider>
      </AuthProvider>
    </CrumbOptionsProvider>
  </React.StrictMode>
);
